import { render, staticRenderFns } from "./Contacts-list.vue?vue&type=template&id=df1a356e&"
import script from "./Contacts-list.vue?vue&type=script&lang=js&"
export * from "./Contacts-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports